"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allergens = void 0;
const allergens = exports.allergens = [{
  id: 0,
  title: "site.ui.allergens.A",
  value: "A"
}, {
  id: 1,
  title: "site.ui.allergens.B",
  value: "B"
}, {
  id: 2,
  title: "site.ui.allergens.C",
  value: "C"
}, {
  id: 3,
  title: "site.ui.allergens.D",
  value: "D"
}, {
  id: 4,
  title: "site.ui.allergens.E",
  value: "E"
}, {
  id: 5,
  title: "site.ui.allergens.F",
  value: "F"
}, {
  id: 6,
  title: "site.ui.allergens.G",
  value: "G"
}, {
  id: 7,
  title: "site.ui.allergens.H",
  value: "H"
}, {
  id: 8,
  title: "site.ui.allergens.L",
  value: "L"
}, {
  id: 9,
  title: "site.ui.allergens.M",
  value: "M"
}, {
  id: 10,
  title: "site.ui.allergens.N",
  value: "N"
}, {
  id: 11,
  title: "site.ui.allergens.O",
  value: "O"
}, {
  id: 12,
  title: "site.ui.allergens.P",
  value: "P"
}, {
  id: 13,
  title: "site.ui.allergens.R",
  value: "R"
}];